/* Lazy, muted, in-viewport-only playback for PDP story and customer videos (HQ 720p mobile, 1080p desktop).
   iOS Safari: muted must be set as a PROPERTY, autoplay can be refused (Low Power Mode) -> visible tap-to-play fallback. */
(() => {
  if (window.pwPdpVideo) return;
  window.pwPdpVideo = true;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const style = document.createElement('style');
  style.textContent = '.pw-vplay{position:absolute;inset:0;z-index:3;display:flex;align-items:center;justify-content:center;width:100%;height:100%;margin:0;padding:0;border:0;background:transparent;cursor:pointer;-webkit-tap-highlight-color:transparent}.pw-vplay[hidden]{display:none}.pw-vplay span{display:flex;align-items:center;justify-content:center;width:64px;height:64px;border-radius:50%;background:rgba(0,0,0,.55);color:#fff;box-shadow:0 2px 12px rgba(0,0,0,.35)}.pw-vplay svg{width:26px;height:26px;margin-left:3px;fill:currentColor}';
  document.head.appendChild(style);

  const button = video => {
    if (video.pwBtn) return video.pwBtn;
    const host = video.parentElement;
    if (getComputedStyle(host).position === 'static' && !host.hasAttribute('data-socials-card')) host.style.position = 'relative';
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'pw-vplay';
    b.hidden = true;
    b.setAttribute('aria-label', 'Play video');
    b.innerHTML = '<span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg></span>';
    b.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      video.dataset.userPlay = '1';
      attempt(video, true);
    });
    host.appendChild(b);
    return (video.pwBtn = b);
  };

  const load = video => {
    if (video.dataset.loaded) return;
    video.dataset.loaded = '1';
    video.src = matchMedia('(min-width: 750px)').matches ? video.dataset.srcLarge : video.dataset.srcSmall;
    video.load();
  };

  const attempt = (video, user) => {
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    load(video);
    const p = video.play();
    if (p && p.catch) p.catch(() => { video.dataset.want = '1'; if (!user) button(video).hidden = false; });
  };

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(({ target, isIntersecting, intersectionRatio }) => {
    if (isIntersecting && intersectionRatio >= 0.4) {
      if (reduce.matches && !target.dataset.userPlay) { button(target).hidden = false; return; }
      attempt(target, false);
    } else if (!target.paused) target.pause();
  }), { threshold: [0, 0.4] }) : null;

  const init = () => document.querySelectorAll('video[data-pw-video]:not([data-pw-bound])').forEach(video => {
    video.dataset.pwBound = '1';
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.playsInline = true;
    const btn = button(video);
    video.addEventListener('playing', () => { btn.hidden = true; delete video.dataset.want; });
    video.addEventListener('canplay', () => { if (video.paused && video.dataset.want) attempt(video, false); });
    video.addEventListener('click', () => { if (video.paused) { video.dataset.userPlay = '1'; attempt(video, true); } });
    if (observer) observer.observe(video);
    else btn.hidden = false;
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
